import React, { Component } from 'react'
import Cards from './components/Cards'

class Events extends Component {
    render() {
        return(
            <Cards />
        )
    }
}

export default Events;